import { render } from "./TasksReset.vue?vue&type=template&id=5a5f4b74"
import script from "./TasksReset.vue?vue&type=script&lang=js"
export * from "./TasksReset.vue?vue&type=script&lang=js"

import exportComponent from "C:\\BestPhone\\bestphone\\main_apps\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__